export const regionLeadOptions = ['Central', 'East', 'West'].map((name) => ({
  label: name,
  value: name
}));

export const electedOptions = [
  { label: 'Yes', value: true },
  { label: 'No', value: false }
];
